import React from 'react';
import {
  Row, Col, Typography, Card, Form, Button, notification,
} from 'antd';
import PropTypes from 'prop-types';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import SelectedLands from '../../../serviceComponents/selectedLands/SelectedLands';
import GeoMapSummary from '../../../serviceComponents/geoMapSummary/GeoMapSummary';
import DetailsFields from '../detailsEdit/DetailsEdit';
import './Details.scss';

const Details = (props): JSX.Element => {
  const {
    removeSelectedField,
    serviceRequestParameters,
    nextPage,
    previousPage,
  } = props;

  const [formInstance] = Form.useForm();

  const handleSubmit = (values): void => {
    const fields = Object.entries(values);
    let verifyValorUnitario = formInstance.getFieldValue('GEOFERT-COLETA-POR-TALHOES-VALOR_UNITARIO');
    let verifyValorTotal = formInstance.getFieldValue('GEOFERT-COLETA-POR-TALHOES-VALOR_TOTAL');
    const verifyCondicaoPagamento = formInstance.getFieldValue('GEOFERT-COLETA-POR-TALHOES-CONDICAO_PAGAMENTO');
    const verifyFormaPagamento = formInstance.getFieldValue('GEOFERT-COLETA-POR-TALHOES-FORMA_PAGAMENTO');

    if (verifyValorUnitario == '0,00') {
      verifyValorUnitario = null;
    }

    if (verifyValorTotal == '0,00') {
      verifyValorTotal = null;
    }

    if (
      (
        (verifyValorUnitario === undefined || verifyValorUnitario === null || verifyValorUnitario === '')
        && (verifyValorTotal === undefined || verifyValorTotal == null || verifyValorTotal === '')
        && (verifyCondicaoPagamento === undefined || verifyCondicaoPagamento === null || verifyCondicaoPagamento === '')
        && (verifyFormaPagamento === undefined || verifyFormaPagamento === null || verifyFormaPagamento === '')
      ) || (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
        && (verifyCondicaoPagamento !== undefined && verifyCondicaoPagamento !== null && verifyCondicaoPagamento !== '')
        && (verifyFormaPagamento !== undefined && verifyFormaPagamento !== null && verifyFormaPagamento !== '')
      )
    ) {
      if (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
      ) {
        fields.map((item): void => {
          if (item[0] === 'GEOFERT-COLETA-POR-TALHOES-VALOR_UNITARIO') {
            item[1] = verifyValorUnitario.replaceAll('.', '').replaceAll(',', '.');
          }

          if (item[0] === 'GEOFERT-COLETA-POR-TALHOES-VALOR_TOTAL') {
            item[1] = verifyValorTotal.replaceAll('.', '').replaceAll(',', '.');
          }
        });
      } else {
        fields.map((item): void => {
          if (item[0] === 'GEOFERT-COLETA-POR-TALHOES-VALOR_UNITARIO') {
            item[1] = null;
          }

          if (item[0] === 'GEOFERT-COLETA-POR-TALHOES-VALOR_TOTAL') {
            item[1] = null;
          }
        });
      }

      nextPage({
        ...serviceRequestParameters,
        details: {
          ...values,
        },
        serviceRequestFieldInputList: fields.map((fieldValue) => {
          return ({
            idCode: fieldValue[0],
            value: fieldValue[1] || '',
          });
        }).filter((fieldValue) => {
          return fieldValue.value != null
            || fieldValue.idCode.includes('VALOR_UNITARIO')
            || fieldValue.idCode.includes('VALOR_TOTAL')
            || fieldValue.idCode.includes('CONDICAO_PAGAMENTO')
            || fieldValue.idCode.includes('FORMA_PAGAMENTO')
            || fieldValue.idCode.includes('OBSERVACOES');
        }),
      });
    } else {
      notification.warning({
        message: 'AVISO',
        description: 'Todos os campos referentes aos valores e pagamento do orçamento devem ser preenchidos ou estarem vazios.',
      });
    }
  };

  return (
    <div className="ColetaPorTalhoesDetails">
      <Row
        justify="space-between"
        className="ColetaPorTalhoesDetails__TitleRow"
      >
        <Col
          className="ColetaPorTalhoesDetails__TitleCol"
        >
          <Typography.Title
            level={1}
            className="ColetaPorTalhoesDetails__Title"
          >
            Novo Serviço: Geofert
          </Typography.Title>
        </Col>
      </Row>
      <Row
        gutter={[24, 24]}
        className="ColetaPorTalhoesDetails__ContentRow"
      >
        <Col
          span={24}
          className="ColetaPorTalhoesDetails__ContentColumn"
        >
          <Card
            className="ColetaPorTalhoesDetails__ContentCard"
          >
            <Row
              gutter={[24, 24]}
              className="ColetaPorTalhoesDetails__FormRow"
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="ColetaPorTalhoesDetails__FormColumn"
              >
                <Form
                  scrollToFirstError
                  className="ColetaPorTalhoesDetails__Form"
                  layout="vertical"
                  form={formInstance}
                  onFinish={handleSubmit}
                  onFinishFailed={
                    (errorInfo): void => {
                      console.log('ColetaPorTalhoesDetails onFinishFailed', errorInfo);
                    }
                  }
                >
                  <Row
                    gutter={[24, 24]}
                    className="ColetaPorTalhoesDetails__FirstFieldRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="ColetaPorTalhoesDetails__FirstFieldColumn"
                    >
                      <Form.Item
                        className="ColetaPorTalhoesDetails__FirstFieldFormItem"
                      >
                        <p className="ColetaPorTalhoesDetails__NonInputInformativeText ColetaPorTalhoesDetails__FirstParagraph">
                          Os pontos amostrados são divididos por talhão,
                          um ponto central georreferenciado mais nove subamostras,
                          em cada talhão. Após a amostragem de solo, as amostras
                          identificadas são encaminhadas para análise laboratorial,
                          gerando laudo de análise de solo.
                        </p>

                        <p className="ColetaPorTalhoesDetails__NonInputInformativeText ColetaPorTalhoesDetails__SecondParagraph">
                          Macronutrientes: P(resina ou mehlich), M.O, pH(CaCl2),
                          Ca, Mg, K, H+Al, SB, T, V%, Al, S.
                        </p>

                        <p className="ColetaPorTalhoesDetails__NonInputInformativeText ColetaPorTalhoesDetails__ThirdParagraph">
                          Micronutrientes: B, Cu, Fe, Mn, Zn.
                        </p>

                        <p className="ColetaPorTalhoesDetails__NonInputInformativeText ColetaPorTalhoesDetails__FourthParagraph">
                          Textura: Argila, Silte, Areia Fina, Areia Grossa, Areia Total.
                        </p>
                      </Form.Item>
                    </Col>
                  </Row>

                  <DetailsFields
                    initialValuesObject={
                      serviceRequestParameters
                        ?.serviceRequestFieldInputList?.length
                        ? Object.fromEntries(
                          serviceRequestParameters
                            ?.serviceRequestFieldInputList
                            ?.map(
                              (val) => {
                                return [val.idCode, val.value];
                              },
                            ),
                        )
                        : undefined
                    }
                  />

                </Form>
              </Col>

              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="ColetaPorTalhoesDetails__LandAndSummaryColumn"
              >
                <SelectedLands
                  talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                  removeSelectedField={removeSelectedField}
                />
                <GeoMapSummary params={serviceRequestParameters} />
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              justify="end"
              className="ColetaPorTalhoesDetails__ButtonRow"
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="ColetaPorTalhoesDetails__ButtonFirstColumn"
              >
                <Button
                  block
                  className="ColetaPorTalhoesDetails__BackButton"
                  onClick={
                    (): void => {
                      previousPage();
                    }
                  }
                >
                  <ArrowLeftIcon className="ColetaPorTalhoesDetails__ArrowLeftIcon" />
                  Voltar
                </Button>
              </Col>
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="ColetaPorTalhoesDetails__ButtonSecondColumn"
              >
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  className="ColetaPorTalhoesDetails__ContinueButton"
                  onClick={
                    (eventt): void => {
                      eventt.preventDefault();
                      formInstance.submit();
                    }
                  }
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Details.propTypes = {
  removeSelectedField: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  serviceRequestParameters: PropTypes.shape({
    serviceRequestFieldInputList: PropTypes.arrayOf(PropTypes.shape({})),
    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.any).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.any),
    service: PropTypes.string,

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};
Details.defaultProps = {};

export default Details;
